<template>
  <div class="home_main">
    <div class="data_box">
      <div class="pandect">
        <!--<div>-->
          <!--<div style="display: flex;justify-content: flex-start">-->
            <!--<div>-->
              <!--<canvas class="qrcode" ref="qrCodeUrl" id="creatCode"></canvas>-->
              <!--<el-select v-model="chargeSize" size="mini"-->
                         <!--style="width: 140px;margin: 0 auto;display: block;">-->
                <!--<el-option v-for="item in options" :key="item.value"-->
                           <!--:label="item.label" :value="item.value">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</div>-->
            <!--<div v-if="wxSchemaUrl">-->
              <!--<img :src="wxSchemaUrl" style="width: 180px;margin-left: 20px;">-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
        <div class="home_data_box">
          <div class="home_data_statistics">
            <div>
              <p class="data_main">{{homeData.buildingCount || 0}}</p>
              <p class="data_title">总楼数</p>
            </div>
            <div>
              <p class="data_main">{{homeData.totalArea || 0}} <span class="data_title">m²</span></p>
              <p class="data_title">总面积</p>
            </div>
            <div>
              <p class="data_main">{{homeData.leasedArea || 0}} <span class="data_title">m²</span></p>
              <p class="data_title">已租面积: {{homeData.leasedAreaPercent}}</p>
            </div>
            <div>
              <p class="data_main">{{homeData.unleasedArea || 0}} <span class="data_title">m²</span></p>
              <p class="data_title">未租面积: {{homeData.unleasedAreaPercent}}</p>
            </div>
            <div>
              <p class="data_main">{{homeData.enterpriseCount || 0}}</p>
              <p class="data_title">入驻住户数量</p>
            </div>
            <!--<div>-->
              <!--<p class="data_main">{{homeData.avgRent}}<span class="data_title"> 元/平米/天</span></p>-->
              <!--<p class="data_title">在租均价</p>-->
            <!--</div>-->
          </div>
          <div class="home_data_statistics">
            <div>
              <p class="data_main">{{homeData.predictYearRent || 0}} <span class="data_title">万元</span></p>
              <p class="data_title">年收入预计总额</p>
            </div>
            <div>
              <p class="data_main">{{homeData.oneYearRent || 0}} <span class="data_title">万元</span></p>
              <p class="data_title">年租金收入总额</p>
            </div>
            <div>
              <p class="data_main">{{homeData.totalPeople || 0}}</p>
              <p class="data_title">入驻人员总数量</p>
            </div>
            <div>
              <p class="data_main">{{homeData.receiveCardPeople || 0}}</p>
              <p class="data_title">领卡人员数量</p>
            </div>
            <div>
              <p class="data_main">{{homeData.visitor || 0}}</p>
              <p class="data_title">访客人员数量</p>
            </div>
          </div>
        </div>
      </div>
      <div class="all-table-class">
        <el-table
          :data="tableData"
          height="241"
          @row-click="buildingRowClick"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="楼栋名称">
          </el-table-column>
          <el-table-column
            prop="totalArea"
            label="总面积(m²)">
          </el-table-column>
          <el-table-column
            prop="rentArea"
            label="已租面积(m²)">
          </el-table-column>
          <el-table-column
            prop="unRentArea"
            label="未租面积(m²)">
          </el-table-column>
          <el-table-column
            prop="rentAreaPercent"
            label="已租比例">
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="avgPrice"-->
            <!--label="在租均价">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="enterpriseCount"
            label="入驻住户总数">
          </el-table-column>
        </el-table>
      </div>

      <!--<table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />-->
    </div>

    <div class="service">
      <div class="service_box">
        <h2>资源中心</h2>
        <div class="icon_box">
          <div :class="{blue: basicServicesState === '1' , grey: basicServicesState === '0', yellow: basicServicesState === '2'}" @click="enterServer('housing-management', basicServicesState, 'resource')">
            <i class="el-icon-damai-fangyuan-xuanzhong"></i>
            <span>房屋管理</span>
          </div>
          <div :class="{blue: basicServicesState === '1' , grey: basicServicesState === '0', yellow: basicServicesState === '2'}" @click="enterServer('business-management', basicServicesState, 'resource')">
            <i class="el-icon-damai-qiye1"></i>
            <span>住户管理</span>
            <div class="service_tip" v-if="basicServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: basicServicesState === '1' , grey: basicServicesState === '0', yellow: basicServicesState === '2'}" @click="enterServer('person-management', basicServicesState, 'resource')">
            <i class="el-icon-damai-renyuan-copy"></i>
            <span>人员管理</span>
            <div class="service_tip" v-if="basicServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: basicServicesState === '1' , grey: basicServicesState === '0', yellow: basicServicesState === '2'}" @click="enterServer('config-card', basicServicesState, 'resource')">
            <i class="el-icon-damai-qiabao1"></i>
            <span>卡包管理</span>
            <div class="service_tip" v-if="basicServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
        </div>

      </div>
      <div class="service_box">
        <h2>智慧合约</h2>
        <div class="icon_box">
          <div :class="{blue: investmentLeasingState === '1' , grey: investmentLeasingState === '0', yellow: investmentLeasingState === '2'}" @click="enterServer('custom-management', investmentLeasingState, 'investment')">
            <i class="el-icon-damai-kehu"></i>
            <span>客户管理</span>
            <div class="service_tip" v-if="investmentLeasingState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: investmentLeasingState === '1' , grey: investmentLeasingState === '0', yellow: investmentLeasingState === '2'}" @click="enterServer('contract-management', investmentLeasingState, 'investment')">
            <i class="el-icon-damai-hetong"></i>
            <span>合同管理</span>
            <div class="service_tip" v-if="investmentLeasingState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: investmentLeasingState === '1' , grey: investmentLeasingState === '0', yellow: investmentLeasingState === '2'}" @click="enterServer('rent-management', investmentLeasingState, 'investment')">
            <i class="el-icon-damai-zujinshezhi"></i>
            <span>租金管理</span>
            <div class="service_tip" v-if="investmentLeasingState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
        </div>

      </div>
    </div>

    <div class="service qy-service">
      <div class="service_box" style="width: 100%">
        <h2>园区服务</h2>
        <div class="icon_box">
          <div :class="{blue: accessCtrlServicesState === '1' , grey: accessCtrlServicesState === '0', yellow: accessCtrlServicesState === '2'}" @click="enterServer('accessCtrlDeviceManagementCenter', accessCtrlServicesState, 'application')">
            <i class="el-icon-damai-access"></i>
            <span>智慧门禁</span>
            <div class="service_tip" v-if="accessCtrlServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: yqServicesState === '1' , grey: yqServicesState === '0', yellow: yqServicesState === '2'}" @click="enterServer('amount-allocation', yqServicesState, 'application')">
            <i class="el-icon-damai-socar_parking_icon"></i>
            <span>智慧停车</span>
            <div class="service_tip" v-if="yqServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: electricServicesState === '1' , grey: electricServicesState === '0', yellow: electricServicesState === '2'}" @click="enterServer('electronic-config', electricServicesState, 'application')">
            <i class="el-icon-damai-liuliang"></i>
            <span>智慧用电</span>
            <div class="service_tip" v-if="electricServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: payServicesState === '1' , grey: payServicesState === '0', yellow: payServicesState === '2'}" @click="enterServer('receiving-account-configuration', payServicesState, 'application')">
            <i class="el-icon-damai-wuyejiaofei1"></i>
            <span>缴费服务</span>
            <div class="service_tip" v-if="payServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: visitorServicesState === '1' , grey: visitorServicesState === '0', yellow: visitorServicesState === '2'}" @click="enterServer('appointment-record', visitorServicesState, 'application')">
            <i class="el-icon-damai-fangke1"></i>
            <span>智慧访客</span>
            <div class="service_tip" v-if="visitorServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
          <div :class="{blue: siteServicesState === '1' , grey: siteServicesState === '0', yellow: siteServicesState === '2'}" @click="enterServer('site-management', siteServicesState, 'application')">
            <i class="el-icon-damai-changdi-tianchong"></i>
            <span>智慧预约</span>
            <div class="service_tip" v-if="siteServicesState === '2'" style="background-color: #FFA10E">试用</div>
          </div>
        </div>
      </div>
      <!--<div class="service_box">-->
        <!--<h2>服务联盟</h2>-->
        <!--<div class="icon_box">-->
          <!--<div>-->
            <!--<i class="el-icon-damai-fangyuan"></i>-->
            <!--<span>房屋管理</span>-->
          <!--</div>-->
          <!--<div>-->
            <!--<i class="el-icon-damai-qiye"></i>-->
            <!--<span>住户管理</span>-->
          <!--</div>-->
          <!--<div>-->
            <!--<i class="el-icon-damai-renyuan"></i>-->
            <!--<span>人员管理</span>-->
          <!--</div>-->
        <!--</div>-->
        <!--<el-button type="primary" plain class="enter_service" :disabled="serviceAlliance === '0'">进入系统</el-button>-->
        <!--<div class="service_tip" v-if="serviceAlliance === '0'" style="background-color: #cccccc">未开通</div>-->
        <!--<div class="service_tip" v-if="serviceAlliance === '1'" style="background-color: #00a0e6">已开通</div>-->
        <!--<div class="service_tip" v-if="serviceAlliance === '2'" style="background-color: #FFA10E">试用中</div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
import QrCodeWithLogo from 'qr-code-with-logo'
import NavMenu from '../components/NavMenu/NavMenu'
import NavList from '../components/NavMenu/NavList'
import {api} from './api/Config'
import {errorHandler} from '../utils/errorHandler'
import {bus} from '../utils/bus'
import FootText from '../components/FootText/FootText'
import TableMain from '../components/Table/TableMain'

export default {
  name: 'homepage',
  components: {
    TableMain,
    FootText,
    NavList,
    NavMenu
  },
  data () {
    return {
      homeData: '',           // 园区数据统计
      permissionCodes: '',
      yqName: '',
      yqIntroduce: '',
      yqTotalArea: '',
      yqIconUrl: '',
      wxSchemaUrl: '',
      codes: '',
      visitorServicesState: '0',
      payServicesState: '0',
      electricServicesState: '0',
      basicServicesState: '0',
      investmentLeasingState: '0',
      yqServicesState: '0',
      accessCtrlServicesState: '0',
      siteServicesState: '0',
      options: [{
        value: 256,
        label: '256*256'
      }, {
        value: 512,
        label: '512*512'
      }, {
        value: 800,
        label: '800*800'
      }],
      chargeSize: 256,
      tableData: []
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getHomeData()
    this.getBuildingList()
    this.getYqInfo()
    // this.getYqServerConfig()
  },
  methods: {
    enterServer (name, state, navTop) {
      if (state === '0') {
        this.$confirm('暂未开通此功能，若想使用此功能请联系官方客服。')
        return false
      } else {
        window.sessionStorage.setItem('navTop', navTop)
        this.$router.push({
          name: name
        })
      }
    },
    getBuildingList() {
      this.$axios.post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.map(v => {
              for (let i in v) {
                if (!v[i]) {
                  v[i] = '--'
                }
              }
            })
            this.tableData = data
          }
        })
        .catch(errorHandler('获取楼栋数据失败'))
    },
    buildingRowClick (row) {
      window.sessionStorage.setItem('housingManagementPageBuildingTabState', row.code)
      window.sessionStorage.setItem('housingManagementPageHousingTabState', 'housing_resources')
      window.sessionStorage.setItem('navTop', 'resource')
      this.$router.push({
        name: 'housing-management'
      })
    },
    getHomeData () {
      this.$axios.post(api.getHomeData, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.homeData = res.data.data
          }
        })
        .catch(errorHandler('查询信息失败'))
    },
    getYqInfo () {
      if (this.permissionCodes.indexOf('001001000') !== -1) {
        this.$axios.post(api.getYqInfo, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.yqIconUrl = data.yqIconUrl
              this.yqName = data.yqName
              this.yqIntroduce = data.yqIntroduce
              this.yqTotalArea = data.yqTotalArea
              this.codes = data.schemaUrl
              this.wxSchemaUrl = data.wxSchemaUrl
              this.getCodes()
            }
          })
          .catch(errorHandler('查询园区信息失败'))
      }
    },
    getYqServerConfig () {
      this.$axios.post(api.getYqServerConfig, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            data.map(v => {
              if (v.configValue === 'PA') {
                this.visitorServicesState = v.configStatus
              }
              if (v.configValue === 'PB') {
                this.payServicesState = v.configStatus
              }
              if (v.configValue === 'PC') {
                this.yqServicesState = v.configStatus
              }
              if (v.configValue === 'PD') {
                this.electricServicesState = v.configStatus
              }
              if (v.configValue === 'PE') {
                this.basicServicesState = v.configStatus
              }
              if (v.configValue === 'PF') {
                this.investmentLeasingState = v.configStatus
              }
              if (v.configValue === 'PG') {
                this.accessCtrlServicesState = v.configStatus
              }
              if (v.configValue === 'PH') {
                this.siteServicesState = v.configStatus
              }
            })
          }
        })
        .catch(errorHandler('查询公寓服务状态失败'))
    },
    getCodes () {
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById('creatCode'),
          content: this.codes,
          width: this.chargeSize,
          logo: {
            src: this.yqIconUrl
          }
        })
          .catch()
      }, 100)
    }
  },
  watch: {
    chargeSize (Val) {
      QrCodeWithLogo.toCanvas({
        canvas: document.getElementById('creatCode'),
        content: this.codes,
        width: this.chargeSize,
        logo: {
          src: this.yqIconUrl,
          borderRadius: 0,
          borderSize: 0.01,
          logoSize: 0.17,
        }
      }).catch(e => console.error(e))
    }
  }
}
</script>

<style scoped>
  #app {
    background-color: white;
  }
  .home_main {
    width: 80%;
    margin: 30px auto 0;
  }
  .data_box {
    border-radius: 15px;
    border: 1px solid #00a0e6;
    padding-bottom: 30px;
  }
  .pandect {
    display: flex;
    justify-content: space-between;
    height: 240px;
    padding: 20px;
    margin-bottom: 20px;
  }
  .pandect p {
    line-height: 32px;
  }
  .pandect>div {
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .pandect .home_data_box {
    flex: 1;
    height: 200px;
    margin: 15px 0 10px 30px;
  }
  .pandect .home_data_statistics {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
  }
  .home_data_statistics>div {
    width: 20%;
  }
  .data_main {
    font-weight: 700;
    font-size: 20px;
    color: #333333;
  }
  .data_title {
    font-weight: 400;
    color: #a6a6a6;
    font-size: 14px;
  }
  .service {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
  }

  .service_box {
    width: 46%;
    min-width: 500px;
    height: 200px;
    border-radius: 15px;
    padding: 10px 30px;
    border: 1px solid #00a0e6;
    overflow: hidden;
    position: relative;
  }

  .service_box h2 {
    margin-top: 15px;
  }

  .icon_box {
    display: flex;
    margin: 40px auto 0;
    width: 80%;
    justify-content: space-between;
  }
  .icon_box i {
    font-size: 30px;
    margin-bottom: 8px;
  }
  .qy-service i{
    font-size: 40px;
  }
  .icon_box>div {
    width: 70px;
    height: 70px;
    min-width: 70px;
    min-height: 70px;
    padding: 4px;
    display: flex;
    color: #999999;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: 8px;
    border: 1px solid #999999;
    position: relative;
    overflow: hidden;
  }
  .qy-service .icon_box>div {
    width: 80px;
    height: 80px;
  }
  .icon_box .blue{
    cursor: pointer;
    color: #00A0E6;
    border: 1px solid #00A0E6;
  }
  .icon_box .grey{
    cursor: not-allowed;
    color: #a6a6a6;
    border: 1px solid #a6a6a6;
  }
  .icon_box .yellow{
    cursor: pointer;
    color: #FFA10E;
    border: 1px solid #FFA10E;
  }
  .enter_service {
    margin-top: 30px;
  }
  .service_tip {
    width: 60px;
    height: 15px;
    line-height: 17px;
    color: #FFFFFF;
    font-size: 12px;
    transform: rotate(45deg);
    position: absolute;
    right: -20px;
    top: 3px;
  }
  #creatCode {
    display: block;
    width: 180px !important;
    height: 180px !important;
    margin: 0 auto;
    position: relative;
  }
</style>

<style lang="less">
  .all-table-class {
    .el-table thead {
      color: #48576a;
    }
    .el-table::before {
      height: 0;
    }
    .el-table .el-table__header tr {
      background-color: #eff1f5;
      th {
        background-color: #eff1f5;
      }
    }
    .el-table .cell {
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-button--text {
      color: #00A0E6;
      font-size: 14px;
      :hover {
        color: #06b3ff;
      }
    }
    .el-table td {
      padding: 8px 0;
    }
    tbody {
      overflow: scroll;
    }
    .el-pagination {
      margin-top: 20px;
    }
    tbody {
      .el-table__row {
        cursor: pointer
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/homepage.vue